import React from 'react';
import Icon1 from '../../assets/ficon_1.svg';
import Icon2 from '../../assets/ficon_2.svg';
import Icon3 from '../../assets/ficon_3.svg';
import Icon4 from '../../assets/ficon_4.svg';
import Icon5 from '../../assets/ficon_5.svg';
import parse from 'html-react-parser';
import './features.css';

const Features = () => {
  const featuresList = [
    {
      icon: Icon1,
      name: "Download the app",
      desc:  `Download our app from the <br /> <a href="#google">Google Playstore</a> or <a href="#google">App store</a>`,
    },

    {
      icon: Icon2,
      name: "Select your preferred services",
      desc:  `Choose from a range of services and we’ll take it from there`,
    },

    {
      icon: Icon3,
      name: "Build the caregiver profile",
      desc:  `Build the caregiver profile and fund your account to confirm the booking.`,
    },

    {
      icon: Icon4,
      name: "We develop a care plan for you",
      desc:  `Our matching technology develops the care plan and matches you to the perfect caregiver`,
    },

    {
      icon: Icon5,
      name: "Our care giver is assigned to you",
      desc:  `Sit back and relax as the caregiver shows up at your door`,
    }
  ];


  return (
    <div className='gmc__features section__padding'>
      <h2>How it works</h2>
      <p>Getting a Care Expert in your home has never <br/> been easier.</p>

      <div className='gmc__features-list'>
        {featuresList.map((item, index)=>(
       
          <div className='gmc__features-list-item' key={item.name}>
            <div className='gmc__features-list-item_image'>
              <img src={item.icon} alt={item.name}/>
            </div>
            <h4>{item.name}</h4>
            <p>{parse(item.desc)}</p>
          </div>
        ))}
        
      </div>
    </div>
  )
}

export default Features